import styled from 'styled-components';

import { createTranslatedText } from '@dreryk/react-common';
import {
   EmptyStatePlaceholder,
   EmptyStatePlaceholderVariant,
   Link,
   SecondaryText,
   StyledFlex,
} from '@dreryk/react-components';

import { prescriptionsHistoryDownloadTranslationKeys } from './translations';

type P1CommunicationFaultPlaceholderProps = {
   readonly onTryAgainLinkClick: VoidFunction;
   readonly faultDescription?: string;
};

const StyledTryAgainLink = styled(Link)`
   display: block;
   margin-top: 8px;
`;
StyledTryAgainLink.displayName = 'StyledTryAgainLink';

export const P1CommunicationFaultPlaceholder = (props: P1CommunicationFaultPlaceholderProps): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         testId={'p1CommunicationFault'}
         heading={prescriptionsHistoryDownloadTranslationKeys.p1CommunicationFault}
         variant={EmptyStatePlaceholderVariant.NEGATIVE}
         subheading={
            <StyledFlex direction={'column'} gap={'8px'}>
               {props.faultDescription ? (
                  <SecondaryText testId={'p1FaultDescription'} text={createTranslatedText(props.faultDescription)} />
               ) : null}
               <Link
                  testId={'tryAgain'}
                  label={prescriptionsHistoryDownloadTranslationKeys.tryAgain}
                  onClick={props.onTryAgainLinkClick}
               />
            </StyledFlex>
         }
      />
   );
};
